import React, { Component } from 'react';

export default class PromotionTile extends Component {
    getDescription(discountData, ) {
        const empty = '\xa0';
        switch (discountData.discountsDefinitionsID) {
            case 1:
                return empty;
            case 2:
                return empty;
            case 3:
                return (discountData.description = discountData.numberOfInstallment + ' rat');
            case 4:
                this.props.discountData.discountValue = 100;
                return (discountData.description =
                    'po racie nr ' + discountData.forInstallmentNumber);
            case 5:
                return (discountData.description =
                    'od ' +
                    (discountData.fromInstallment ) +
                    ' do ' +
                    discountData.toInstallment);
            case 6:
                return empty;
            case 7:
                return empty;
            case 8:
                return (discountData.description = 'nr ' + discountData.forInstallmentNumber);
            case 9:
                return empty;
            case 10:
                return (discountData.description =
                    'wybrana rata ' + discountData.forInstallmentNumber);
            case 11:
                return (discountData.description =
                    'dla ' + discountData.numberOfInstallment + ' rat');
            case 12:
                return empty;
            case 13:
                return empty;
        }
    }

    render() {
        return (
            <div className={this.props.classType.promo_tile}>
                <div className="promo_tile_row promo_tile_title">
                    {this.props.discountData.discountName}
                </div>
                <div className={this.props.classType.promo_tile_row}>
                    {this.props.discountData.discountsTypesDVID === 1 ? (
                        <span>- {this.props.discountData.discountValue} %</span>
                    ) : this.props.discountData.discountsTypesDVID === 2 ? (
                        <span>- {this.props.discountData.discountValue + ' '} zł</span>
                    ) : (
                        <span>{this.props.discountData.discountValue}</span>
                    )}
                </div>
                <div className="promo_tile_row">{this.getDescription(this.props.discountData)}</div>
            </div>
        );
    }
}
